import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-dark/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-3'}`} data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <div className="flex justify-between items-center" data-id="element-99">
          <div className="flex-shrink-0" data-id="element-100">
            <a href="#" className="flex items-center" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/mSQy5D2xr3KB3poJfjsLq1/6008aba0-2278-4ccf-a44f-f03314af6b23.png" alt="AI Web Studio Logo" className="h-14 md:h-20 w-auto brightness-110" data-id="element-102" />
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-103">
            <a href="#ejemplos" className="text-white hover:text-primary transition-colors font-medium" data-id="element-104">
              Ejemplos
            </a>
            <a href="#beneficios" className="text-white hover:text-primary transition-colors font-medium" data-id="element-105">
              Beneficios
            </a>
            <a href="#oferta" className="text-white hover:text-primary transition-colors font-medium" data-id="element-106">
              Oferta
            </a>
            <a href="https://wa.me/34691204745?text=Hola,%20mi%20nombre%20es%20____.%20Soy%20de%20____.%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20web%20profesional%20por%20297%E2%82%AC%20para%20mi%20negocio.%20Gracias." target="_blank" rel="noopener noreferrer" className="bg-primary hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-medium transition-colors" data-id="element-107">
              Contactar
            </a>
          </div>

          <div className="md:hidden flex items-center" data-id="element-108">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2" aria-label="Toggle menu" data-id="element-109">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-110" /> : <MenuIcon className="w-6 h-6" data-id="element-111" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-112">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark border-t border-gray-800" data-id="element-113">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-114">
              <a href="#ejemplos" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-white hover:bg-gray-800 rounded-md font-medium" data-id="element-115">
                Ejemplos
              </a>
              <a href="#beneficios" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-white hover:bg-gray-800 rounded-md font-medium" data-id="element-116">
                Beneficios
              </a>
              <a href="#oferta" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-white hover:bg-gray-800 rounded-md font-medium" data-id="element-117">
                Oferta
              </a>
              <a href="https://wa.me/34691204745?text=Hola,%20mi%20nombre%20es%20____.%20Soy%20de%20____.%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20web%20profesional%20por%20297%E2%82%AC%20para%20mi%20negocio.%20Gracias." target="_blank" rel="noopener noreferrer" className="block w-full text-center mt-4 bg-primary hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition-colors" data-id="element-118">
                Contactar
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}